<div class="my-bookings-container">

   
    <div class="back-button" *ngIf="IsVisible()">
        <button (click)="closeMobileFilter()">
            <mat-icon>arrow_back</mat-icon>
            <span class="back-button-text">Filter</span>
        </button>
    </div>

    
  

    
    <div class="header-section">
        <div class="page-title" *ngIf="!IsVisible()">
            <span>My Bookings</span>
            <button mat-button (click)="openMobileFilter()">
                <img [src]="filterUrl" alt="Filter" class="logo-img" />
                Filter
            </button>
        </div>
        
        <div class="search-filter-section">
            <span class="desktop-title">My Bookings</span>
            <div class="search-box" *ngIf="!IsVisible()">
                <input type="text" placeholder="Search" [(ngModel)]="searchTerm" (input)="searchBookings()"
                    class="search-input">
            </div>
            <div class="date-filters" [formGroup]="dateForm">
                <mat-form-field appearance="outline" class="form-field">
                    <input matInput [matDatepicker]="outstationFromDatePicker" formControlName="fromDate"
                        placeholder="Enter From Date" id="fromDate" readonly>
                    <mat-datepicker-toggle matSuffix [for]="outstationFromDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #outstationFromDatePicker></mat-datepicker>
                </mat-form-field>


                <mat-form-field appearance="outline" class="form-field">
                    <input matInput [matDatepicker]="outstationEndDatePicker" formControlName="toDate"
                        placeholder="Enter End Date" id="toDate" readonly>
                    <mat-datepicker-toggle matSuffix [for]="outstationEndDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #outstationEndDatePicker></mat-datepicker>
                </mat-form-field>
                <button class="show-btn" (click)="searchBookingsDetails()">Show</button>
            </div>
        </div>
    </div>

    @if(isMobile()){
    <div class="mobile-view" *ngIf="!IsVisible()">
        <div class="booking-cards">
            @for(booking of computedFilteredBookings(); track booking.bookingId){
            <mat-card class="booking-card">
                <mat-card-content class="card-content">
                    <div class="status-row">
                        <div class="status-section">
                            <span class="status-label">Status:</span>
                            <span class="status-badge" [class.pending]="booking.bookingStatus.includes('Pending')"
                                [class.confirmed]="booking.bookingStatus.includes('Confirm')">
                                {{ booking.bookingStatus }}
                            </span>
                        </div>
                        <ng-container [ngSwitch]="booking.cancelStatus">
                            <button *ngSwitchCase="1" class="cancel-btn" (click)="cancelBooking(booking.bookingId)">
                                Cancel
                            </button>
                            <span *ngSwitchCase="0" class="no-cancel-text">No Cancellation</span>
                            <!-- Don't show anything for status 2 -->
                        </ng-container>
                    </div>
                    <hr class="card-divider">
                    <div class="detail-row">
                        <span class="detail-label">Booking RefNo:</span>
                        <span class="detail-value">{{ booking.bookingRefNo }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Transaction ID:</span>
                        <span class="detail-value">{{ booking.transactionId }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Customer Name:</span>
                        <span class="detail-value">{{ booking.customerName }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Car Type:</span>
                        <span class="detail-value">{{ booking.carType }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Reporting Date & Time:</span>
                        <span class="detail-value">{{ booking.reportingTime }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Package Name:</span>
                        <span class="detail-value">{{ booking.packageName }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">City:</span>
                        <span class="detail-value">{{ booking.city }}</span>
                    </div>
                </mat-card-content>
            </mat-card>

            }
        </div>
    </div>}
    @else{
    <div *ngIf="!isMobile()" class="desktop-view">
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort class="bookings-table">
                <ng-container matColumnDef="bookingRefNo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Booking Ref.No </th>
                    <td mat-cell *matCellDef="let booking"> {{booking.bookingRefNo}} </td>
                </ng-container>
                <ng-container matColumnDef="transactionId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Transaction Id </th>
                    <td mat-cell *matCellDef="let booking"> {{booking.transactionId}} </td>
                </ng-container>
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Reporting Date </th>
                    <td mat-cell *matCellDef="let booking"> {{booking.date}} </td>
                </ng-container>
                <ng-container matColumnDef="reportingTime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Time </th>
                    <td mat-cell *matCellDef="let booking"> {{booking.reportingTime}} </td>
                </ng-container>
                <ng-container matColumnDef="customerName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer Name </th>
                    <td mat-cell *matCellDef="let booking"> {{booking.customerName}} </td>
                </ng-container>
                <ng-container matColumnDef="carType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Car Type </th>
                    <td mat-cell *matCellDef="let booking"> {{booking.carType}} </td>
                </ng-container>
                <ng-container matColumnDef="packageName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Package Name </th>
                    <td mat-cell *matCellDef="let booking"> {{booking.packageName}} </td>
                </ng-container>
                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> City </th>
                    <td mat-cell *matCellDef="let booking"> {{booking.city}} </td>
                </ng-container>
                <ng-container matColumnDef="bookingStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                    <td mat-cell *matCellDef="let booking">
                        <span class="status-badge" [class.pending]="booking.bookingStatus.includes('Pending')"
                            [class.confirmed]="booking.bookingStatus.includes('Confirm')">
                            {{ booking.bookingStatus }}
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Action </th>
                    <td mat-cell *matCellDef="let booking">
                        <ng-container [ngSwitch]="booking.cancelStatus">
                            <button *ngSwitchCase="1" class="cancel-btn" (click)="cancelBooking(booking.bookingId)">
                                Cancel
                            </button>
                            <span *ngSwitchCase="0" class="no-cancel-text">No Cancellation</span>
                        </ng-container>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" showFirstLastButtons
                aria-label="Select page of bookings"></mat-paginator>
        </div>
    </div>
    }

    @if(isMobile()){
    <div class="fixed-bottom-navigation">
        <app-navigation-tabs [activeTab]="'my-bookings'" (tabChange)="onTabChange($event)">
        </app-navigation-tabs>
    </div>
    }

    <div class="loading-overlay" *ngIf="isBookingLoading">
        <mat-progress-spinner mode="indeterminate" diameter="60" strokeWidth="4"></mat-progress-spinner>
      </div>
</div>

